import React, { useState } from 'react';
import { Layout } from '../Layout';
import Button from '@cloudscape-design/components/button';
import SpaceBetween from '@cloudscape-design/components/space-between';
import { QRCodeScanner } from './QRCodeScanner';
import Box from '@cloudscape-design/components/box';
import Container from '@cloudscape-design/components/container';
import Header from '@cloudscape-design/components/header';

export const QRCheckIn: React.FC = () => {
    const [showQRScanner, setShowQRScanner] = useState(false);

    return (
        <Layout breadcrumbs={[
            {
                href: '/qr-checkin',
                text: 'QR Code Check-in'
            }
        ]}>
            <div style={{ 
                maxWidth: '600px', 
                margin: '0 auto',
                padding: '16px'
            }}>
                {!showQRScanner ? (
                    <Container
                        header={
                            <Header variant="h2">
                                QR Code Check-in Verification
                            </Header>
                        }
                    >
                        <SpaceBetween direction="vertical" size="l">
                            <Box variant="p" fontSize="body-m">
                                Use this feature to verify check-in by scanning QR codes. 
                                The system will automatically read the check-in code and display the corresponding chest number.
                            </Box>
                            <Button 
                                variant="primary" 
                                onClick={() => setShowQRScanner(true)}
                                fullWidth
                            >
                                Scan QR Code
                            </Button>
                        </SpaceBetween>
                    </Container>
                ) : (
                    <QRCodeScanner onClose={() => setShowQRScanner(false)} />
                )}
            </div>
        </Layout>
    );
};
